import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaGithub } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="dark:bg-slate-950 bg-gray-50 border-t dark:border-white/10 border-gray-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12">

          <div className="col-span-2 lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img
                className="h-16 w-auto"
                src="/AutoHire.png"
                alt="AutoHire"
              />
            </Link>
            <p className="dark:text-gray-400 text-gray-600 text-sm leading-relaxed max-w-xs mb-6">
              The AI-native recruiting platform. Automate sourcing, screening, and outreach so you can focus on closing top talent.
            </p>
            <div className="flex space-x-4">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="text-gray-500 hover:text-blue-600 dark:hover:text-white transition-colors"><FaTwitter className="w-5 h-5" /></a>
              <a href="https://www.linkedin.com/company/autohire-works/" className="text-gray-500 hover:text-blue-600 dark:hover:text-white transition-colors"><FaLinkedin className="w-5 h-5" /></a>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="text-gray-500 hover:text-blue-600 dark:hover:text-white transition-colors"><FaGithub className="w-5 h-5" /></a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold dark:text-white text-gray-900 uppercase tracking-wider mb-4">Product</h3>
            <ul className="space-y-3">
              <li><Link to="/product" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/solutions" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Solutions</Link></li>
              <li><Link to="/changelog" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Changelog</Link></li>
              <li><Link to="/integrations" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Integrations</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold dark:text-white text-gray-900 uppercase tracking-wider mb-4">Resources</h3>
            <ul className="space-y-3">
              <li><Link to="/resources" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/resources" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Guides</Link></li>
              <li><a href="mailto:support@autohire.tech" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Help Center</a></li>
              <li><Link to="#" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">API Docs</Link></li>
              <li><Link to="/status" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">System Status</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold dark:text-white text-gray-900 uppercase tracking-wider mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">About</Link></li>
              <li><Link to="/talent" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Join Talent Pool</Link></li>
              <li><Link to="#" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="#" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Legal</Link></li>
              <li><Link to="/contact" className="text-sm dark:text-gray-400 text-gray-600 hover:text-blue-600 dark:hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t dark:border-white/10 border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="dark:text-gray-600 text-gray-500 text-xs">
            © {new Date().getFullYear()} AutoHire Inc. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="dark:text-gray-600 text-gray-500 hover:text-blue-600 dark:hover:text-gray-400 text-xs transition-colors">Privacy Policy</Link>
            <Link to="#" className="dark:text-gray-600 text-gray-500 hover:text-blue-600 dark:hover:text-gray-400 text-xs transition-colors">Terms of Service</Link>
            <Link to="#" className="dark:text-gray-600 text-gray-500 hover:text-blue-600 dark:hover:text-gray-400 text-xs transition-colors">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
